/**
 * academia/index.js — carga todas las lecciones de src/academia/lecciones/*.md (Markdown + frontmatter) al armar la app.
 * Agregar una lección = agregar un archivo; no hay que tocar código.
 *
 *   LECCIONES            todas, ordenadas por id
 *   getLeccion("01")     una lección
 *   getLecciones(ids)    las que existen entre esos ids, en ese orden (rutas.js define qué ids ve cada rol)
 */
import { parsear } from "./frontmatter.js";

const crudas = import.meta.glob("./lecciones/*.md", { query: "?raw", import: "default", eager: true });

/** Los links de video y ficha salen de un archivo editable: solo se aceptan https (nada de javascript: ni data:). */
const urlSegura = (u) => (/^https:\/\//i.test(String(u || "").trim()) ? String(u).trim() : "");

export const LECCIONES = Object.entries(crudas)
  .map(([archivo, texto]) => {
    const { data, body } = parsear(texto);
    return {
      ...data,
      id: String(data.id ?? archivo),
      titulo: data.titulo || "Sin título",
      grupo: data.grupo || "tronco",
      roles: Array.isArray(data.roles) ? data.roles : ["todos"],
      minutos: Number(data.minutos) || 0,
      version: Number(data.version) || 1,
      ruta: data.ruta || "",
      video: urlSegura(data.video),
      ficha: urlSegura(data.ficha),
      pasos: Array.isArray(data.pasos) ? data.pasos : [],
      casos: Array.isArray(data.casos) ? data.casos : [],
      cuerpo: body,
    };
  })
  .sort((a, b) => a.id.localeCompare(b.id, "es", { numeric: true }));

export const getLeccion = (id) => LECCIONES.find(l => l.id === String(id)) || null;

export const getLecciones = (ids) => ids.map(getLeccion).filter(Boolean);
